import FormattedMessage from 'I18n/components/FormattedMessage';
import HomepageHighlightedMember from './HomepageHighlightedMember';
// @ts-expect-error ts-migrate(7016) NOFIX
import avatarImage from 'bender-url!../../../../images/highlightedMembers/kyle-jepson.png';
import { jsx as _jsx } from "react/jsx-runtime";
export default function KyleJepson({
  avatarSize
}) {
  return /*#__PURE__*/_jsx(HomepageHighlightedMember, {
    displayName: "Kyle Jepson",
    roleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.homepage.memberHighlight.members.kyleJepson.role"
    }),
    avatarSrc: avatarImage,
    avatarSize: avatarSize
  });
}